import React from 'react'
import GalleryRegisterPageComponent from './GalleryRegisterPageComponent'

const GalleryRegisterPage = () => {
  return (
    <div>
      <GalleryRegisterPageComponent/>
    </div>
  )
}

export default GalleryRegisterPage
